import {
    IArea,
} from 'store/entities/configuration/configurationModel';

export const getAreaText = (area: IArea) => `${area.id} (${area.description})`;
